module.exports = __webpack_public_path__ + "media/images/icons/SVG/019-f7a0111eaf7202f7c29b6f446968fd56.svg";